export default __webpack_public_path__ + "static/media/aiChat.ee53f7eb.less";